import { ShieldAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Warns that a manually identified prescription request needs staff verification.
 *
 * @since 1.2.0
 * @example
 * ```tsx
 * <ManualIdentificationNotice />
 * ```
 */
export function ManualIdentificationNotice() {
  const { t } = useTranslation();

  return (
    <aside
      data-testid="frontdesk-prescription-manual-unverified-notice"
      className="flex items-center gap-4 rounded-2xl border border-warning/40 bg-warning-soft p-5 text-foreground"
    >
      <span className="grid size-12 shrink-0 place-items-center rounded-xl bg-warning/25 text-warning-ink">
        <ShieldAlert className="size-6" aria-hidden="true" />
      </span>
      <p className="m-0 text-lg leading-normal">
        {t("self-service.prescription.manual-identification.unverified")}
      </p>
    </aside>
  );
}
